var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M991 212L991 240",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 991.5,
    cy: 207.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M986.987 207.19C986.987 203.283 990.288 200.117 994.358 200.117C994.943 200.117 995.511 200.184 996.056 200.308C994.742 199.48 993.187 199 991.519 199C986.814 199 983 202.806 983 207.5C983 212.194 986.814 216 991.519 216C993.814 216 995.895 215.093 997.427 213.62C996.492 214.032 995.454 214.263 994.358 214.263C990.288 214.263 986.987 211.096 986.987 207.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.4 206.6L1000.37 204.146L998.535 205.719L996.304 205.056L997.112 207.337L995.765 209.381L998.1 209.218L999.499 211.144L1000.13 208.763L1002.34 207.909L1000.4 206.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.8545d75263ea0f3262170a16bf53fef9.svg";
export { ForwardRef as ReactComponent };